/* ROMP — Mobility Check quiz
   Recommendation rule: never recommend a subscription whose delivery cycle
   outruns the supply it ships. Plans are variant-locked (1 jar = every 4 wks,
   2 jars = 8 wks, 3 jars = 12 wks), so at 1.5 chews/day no cadence fits and we
   deliberately fall back to a one-time supply. */
(function () {
  var root = document.getElementById('qz');
  if (!root) return;

  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('qzData').textContent); } catch (e) { return; }

  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: CURRENCY
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function fmtDay(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: CURRENCY, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function byJars(n) {
    for (var i = 0; i < DATA.variants.length; i++) if (DATA.variants[i].jars === n) return DATA.variants[i];
    return null;
  }

  /* ---------------- state ---------------- */
  var A = { name: '', weight: '', cpd: 1, age: '', signs: [], since: '' };
  var ORDER = ['intro', '1', '2', '3', '4', '5', 'calc', 'result'];
  var at = 0;

  var steps = {};
  root.querySelectorAll('.qz-step').forEach(function (s) { steps[s.getAttribute('data-step')] = s; });
  var progress = document.getElementById('qzProgress');
  var fill = document.getElementById('qzProgressFill');
  var stepTxt = document.getElementById('qzStepTxt');
  var backBtn = document.getElementById('qzBack');

  function dogName() { return A.name || 'your dog'; }

  function paintNames() {
    root.querySelectorAll('.qz-name').forEach(function (el) { el.textContent = dogName(); });
  }

  function show(i) {
    at = i;
    var key = ORDER[i];
    Object.keys(steps).forEach(function (k) { steps[k].classList.toggle('is-active', k === key); });

    var isQ = ['1', '2', '3', '4', '5'].indexOf(key) > -1;
    progress.hidden = !isQ;
    if (isQ) {
      var n = parseInt(key, 10);
      fill.style.width = (n / 5 * 100) + '%';
      stepTxt.textContent = 'Question ' + n + ' of 5';
      backBtn.style.visibility = n === 1 ? 'hidden' : 'visible';
    }
    paintNames();
    if (key === 'calc') runCalc();
    window.scrollTo({ top: 0, behavior: 'auto' });
    var h = root.querySelector('.qz-step.is-active .qz-q, .qz-step.is-active h1');
    if (h && i > 0) { try { h.focus({ preventScroll: true }); } catch (e) {} }
  }

  function next() { if (at < ORDER.length - 1) show(at + 1); }

  root.querySelectorAll('[data-next]').forEach(function (b) {
    b.addEventListener('click', next);
  });
  backBtn.addEventListener('click', function () { if (at > 0) show(at - 1); });

  /* name step */
  var nameForm = document.getElementById('qzNameForm');
  nameForm.addEventListener('submit', function (e) {
    e.preventDefault();
    A.name = (document.getElementById('qzName').value || '').trim().slice(0, 24);
    next();
  });

  /* option buttons */
  root.querySelectorAll('.qz-opt').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = b.getAttribute('data-q'), val = b.getAttribute('data-val');

      if (q === 'signs') {
        if (val === 'none') {
          root.querySelectorAll('[data-q="signs"]').forEach(function (o) { o.classList.remove('is-on'); });
          b.classList.add('is-on');
          A.signs = ['none'];
        } else {
          var none = root.querySelector('.qz-opt-none');
          if (none) none.classList.remove('is-on');
          b.classList.toggle('is-on');
          A.signs = Array.prototype.map.call(
            root.querySelectorAll('[data-q="signs"].is-on'), function (o) { return o.getAttribute('data-val'); }
          ).filter(function (v) { return v !== 'none'; });
        }
        return;
      }

      b.parentNode.querySelectorAll('.qz-opt').forEach(function (o) { o.classList.remove('is-on'); });
      b.classList.add('is-on');
      A[q] = val;
      if (q === 'weight') A.cpd = parseFloat(b.getAttribute('data-cpd')) || 1;
      setTimeout(next, 180);
    });
  });

  /* ---------------- recommendation ---------------- */
  function build(jars, qty, mode) {
    var v = byJars(jars);
    if (!v) return null;
    if (mode === 'sub' && !v.plan) mode = 'once';
    var unit = mode === 'sub' ? v.plan.price : v.price;
    var total = unit * qty;
    var chews = v.chews * qty;
    var days = Math.floor(chews / A.cpd);
    return {
      mode: mode, jars: jars, qty: qty, variant: v, chews: chews, days: days,
      total: total, wasTotal: v.price * qty,
      perDay: total / days,
      cycle: mode === 'sub' ? (jars === 1 ? 28 : jars === 2 ? 56 : 84) : 0
    };
  }

  function recommend() {
    var cpd = A.cpd, primary, alt, why;
    if (cpd === 1) {
      primary = build(3, 1, 'sub');
      alt = build(1, 1, 'once');
      why = 'Three jars land every 12 weeks — 90 chews, which is 90 days of chews for an 84-day cycle. ' + dogName() + ' never runs out, and it works out cheapest per day.';
    } else if (cpd === 2) {
      primary = build(3, 2, 'sub');
      alt = build(3, 1, 'once');
      why = 'At two chews a day ' + dogName() + ' gets through a jar twice as fast, so this ships six jars every 12 weeks — 180 chews, 90 days of chews for an 84-day cycle. Still the lowest cost per day of anything we offer.';
    } else {
      primary = build(3, 1, 'once');
      alt = build(1, 1, 'once');
      why = 'Our subscription ships on a 4, 8 or 12-week rhythm built around one chew a day. At a chew and a half that rhythm never lines up — ' + dogName() + ' would run dry before the next box. So we\'ve picked the one-time three-jar supply instead: lowest cost per day, and nothing auto-renews.';
    }
    if (primary && !primary.variant.available) primary = null;
    return { primary: primary, alt: alt, why: why };
  }

  function doseLine() {
    var mg = Math.round(A.cpd * 1250);
    var label = A.cpd === 1 ? 'one chew a day' : A.cpd === 1.5 ? 'a chew and a half a day' : 'two chews a day';
    return { label: label, mg: mg.toLocaleString('en-US') };
  }

  function signsLine() {
    var n = A.signs.filter(function (s) { return s !== 'none'; }).length;
    var senior = A.age === '7-9' || A.age === '10+';
    if (n === 0) {
      return 'You\'re not seeing anything yet — which is the best possible time to start. Cartilage wears quietly for years before a dog shows it.';
    }
    if (n <= 2) {
      return 'You flagged ' + n + ' of the six early signs' + (senior ? ', and at ' + dogName() + '\'s age those tend to compound rather than pass' : '') + '. Early is exactly where daily support does the most work.';
    }
    return 'You flagged ' + n + ' of the six early signs' + (senior ? ', on a senior-age big breed' : '') + '. That\'s a pattern worth getting ahead of — and worth a vet check alongside it.';
  }

  /* ---------------- result ---------------- */
  function card(o, kind) {
    if (!o) return '';
    var sub = o.mode === 'sub';
    var save = o.wasTotal - o.total;
    var head = sub
      ? (o.jars * o.qty) + ' jars delivered every ' + (o.cycle / 7) + ' weeks'
      : (o.jars * o.qty) + (o.jars * o.qty === 1 ? ' jar' : ' jars') + ' · one-time';

    return '' +
      '<div class="qz-plan' + (kind === 'primary' ? ' is-primary' : '') + '">' +
        (kind === 'primary' ? '<span class="qz-badge">Recommended for ' + esc(dogName()) + '</span>' : '<span class="qz-alt-label">Rather start smaller?</span>') +
        '<h3>' + head + '</h3>' +
        '<p class="qz-plan-meta">' + o.chews + ' chews · <b>' + o.days + ' days</b> of chews for ' + esc(dogName()) + '</p>' +
        '<div class="qz-price">' +
          '<span class="qz-now">' + fmt(o.total) + '</span>' +
          (sub && save > 0 ? '<span class="qz-was">' + fmt(o.wasTotal) + '</span><span class="qz-save">Save ' + fmt(save) + '</span>' : '') +
        '</div>' +
        '<p class="qz-perday">' + fmtDay(o.perDay) + ' a day</p>' +
        '<button type="button" class="qz-cta' + (kind === 'primary' ? '' : ' qz-cta-ghost') + '" data-add ' +
          'data-vid="' + o.variant.id + '" data-qty="' + o.qty + '"' +
          (sub ? ' data-plan="' + o.variant.plan.id + '"' : '') + '>' +
          (kind === 'primary' ? 'Start ' + esc(dogName()) + '’s plan' : 'Take this instead') +
        '</button>' +
        (sub ? '<p class="qz-plan-note">Skip, pause or cancel any delivery from your account.</p>' : '<p class="qz-plan-note">One payment. Nothing auto-renews.</p>') +
      '</div>';
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderResult() {
    var r = recommend(), d = doseLine(), box = document.getElementById('qzResult');

    if (!r.primary) {
      box.innerHTML = '<div class="qz-plan is-primary"><h3>We\'re restocking</h3>' +
        '<p class="qz-plan-meta">This size is temporarily out of stock. Check the product page for what\'s available right now.</p>' +
        '<a class="qz-cta" href="' + DATA.productUrl + '">See the product</a></div>';
      return;
    }

    box.innerHTML = '' +
      '<span class="eyebrow">' + esc(dogName()) + '’s plan</span>' +
      '<h2 class="qz-result-h">' + d.label.charAt(0).toUpperCase() + d.label.slice(1) + '.</h2>' +
      '<p class="qz-result-lead">' + esc(dogName()) + ' sits in our ' + weightLabel() + ' band, so the daily serving is <b>' + d.label + '</b> — ' + d.mg + ' mg of glucosamine, plus MSM, chondroitin and green-lipped mussel.</p>' +
      '<p class="qz-result-signs">' + signsLine() + '</p>' +
      '<div class="qz-plans">' + card(r.primary, 'primary') + card(r.alt, 'alt') + '</div>' +
      '<p class="qz-why">' + r.why + '</p>' +
      '<div class="qz-inside">' +
        '<h4>In every chew</h4>' +
        '<ul>' +
          '<li><b>1,250 mg</b> Glucosamine HCl</li>' +
          '<li><b>400 mg</b> MSM</li>' +
          '<li><b>150 mg</b> Chondroitin</li>' +
          '<li><b>100 mg</b> Green-lipped mussel</li>' +
        '</ul>' +
      '</div>' +
      '<ul class="qz-trust qz-trust-result">' +
        '<li>90-day money-back guarantee</li>' +
        '<li>NASC certified</li>' +
        '<li>Made in the USA</li>' +
      '</ul>' +
      '<p class="qz-err" id="qzErr" hidden></p>' +
      '<a class="qz-readmore" href="' + DATA.productUrl + '">Read the full ingredient breakdown →</a>';

    box.querySelectorAll('[data-add]').forEach(function (b) { b.addEventListener('click', addToCart); });
  }

  function weightLabel() {
    return { 'u65': 'under 65 lb', '65-100': '65–100 lb', '100-120': '100–120 lb', '120+': '120 lb and up' }[A.weight] || '65–100 lb';
  }

  function addToCart(e) {
    var b = e.currentTarget;
    if (b.dataset.busy) return;
    b.dataset.busy = '1';
    var label = b.textContent;
    b.textContent = 'Adding…';

    var item = { id: parseInt(b.getAttribute('data-vid'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10) || 1 };
    if (b.getAttribute('data-plan')) item.selling_plan = parseInt(b.getAttribute('data-plan'), 10);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error((r.j && r.j.description) || 'Could not add to cart');
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        var e2 = document.getElementById('qzErr');
        if (e2) { e2.textContent = err.message + ' — please try again, or open the product page.'; e2.hidden = false; }
        b.textContent = label;
        delete b.dataset.busy;
      });
  }

  /* ---------------- calc screen ---------------- */
  var calcTxt = document.getElementById('qzCalcTxt');
  function runCalc() {
    var lines = ['Working out the dose…', 'Matching a supply to ' + dogName() + '’s weight…', 'Checking the delivery rhythm…'];
    var i = 0;
    calcTxt.textContent = lines[0];
    var t = setInterval(function () {
      i++;
      if (i < lines.length) { calcTxt.textContent = lines[i]; return; }
      clearInterval(t);
      renderResult();
      show(ORDER.indexOf('result'));
    }, 620);
  }

  show(0);
})();
